import React, { useEffect, } from 'react';
import './style.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CityAdminDetails from 'pages/City/CityInfo/CityAdminUsers';

function CityAdmin(props) {

    useEffect(() => {
    }, [props])

    return (
        <div className="container pad-bot20">
            <Row >
                <Col lg={12} className="coverphoto pad0">
                    <div >
                        <div className="pad-tb30 cover-border">
                            <h3>{props.adminHead}</h3>
                            <p>{props.adminSubHead}</p>
                        </div>
                    </div>

                    <div className="pad-tb30">
                        {props.cityAdminData.length > 0 ?
                            <>
                                {
                                    props.cityAdminData.map((item,i) =>
                                        
                                            <CityAdminDetails
                                                key={i}
                                                propsData={props}
                                                Image={item.avatar_image_url}
                                                adminFirstName={item.firstname}
                                                adminLastName={item.lastname}
                                                adminEmail={item.email}
                                            />
                                        
                                    )
                                }
                            </>
                            :
                            <div className="noUser">No Admin Users</div>
                        }
                    </div>
                    {/* <div className="pad-tb15">
                        <Row>
                            <Col lg={6} md={6} sm={12}>
                                <Form>
                                    <Form.Row>
                                        <Form.Group as={Col} lg="12" controlId="firstName" className="margin-top0">
                                            <i className="fa fa-envelope-o" aria-hidden="true"></i>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="Invite by emial address..."
                                                className="height-50 pad"
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                </Form>
                            </Col>
                            <Col lg={6} md={6} sm={12}>
                                <Button theme="btn-global btn-hover btn-invite invite-width">Send Invite</Button>
                            </Col>
                        </Row>
                    </div> */}
                </Col>
            </Row>
        </div>
    );
}


export default CityAdmin;